import { useQuery } from "@tanstack/react-query";
import type { StraightenerInformationRetrievalFilters } from "../models/StraightenerInformationRetrieval";
import {
	getStraightenerInformationRetrievalData,
	getStraightenerInformationRetrievalPickers,
} from "../repositories/StraightenerInformationRetrievalRepository";

export const useStraightenerInformationRetrievalPickers = (
	start: string,
	end: string,
) =>
	useQuery({
		queryKey: ["straightenerInformationRetrievalPickers", start, end],
		queryFn: ({ signal }) =>
			getStraightenerInformationRetrievalPickers(start, end, signal),
		enabled: !!start && !!end,
	});

/**
 * Loads once a Product is chosen, like the mill page. `selectionReady` holds it
 * back while the filters still carry a selection the dates no longer offer.
 */
export const useStraightenerInformationRetrievalData = (
	filters: StraightenerInformationRetrievalFilters,
	selectionReady: boolean,
) =>
	useQuery({
		queryKey: ["straightenerInformationRetrieval", filters],
		queryFn: ({ signal }) =>
			getStraightenerInformationRetrievalData(filters, signal),
		enabled:
			selectionReady &&
			!!filters.start &&
			!!filters.end &&
			filters.productSizeId != null,
	});
